import React, {
    createContext,
    useContext,
    useEffect,
    useState
} from "react";

import FirebaseAuthService
    from "../firebase/FirebaseAuthService";

import {
    getLoggedInUser,
    getToken,
    isUserLoggedIn,
    logout as logoutStorage
} from "../pages/userapp/ServiceUserApp";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(null);
    const [loading, setLoading] = useState(true);

    // ==========================================
    // Chargement initial
    // ==========================================

    useEffect(() => {
        if (isUserLoggedIn()) {
            setUser(getLoggedInUser());
            setToken(getToken());
        }
        setLoading(false);

    }, []);

    // ==========================================
    // Google
    // ==========================================

    const loginGoogle = async () => {
        const login =
            await FirebaseAuthService.loginWithGoogle();
        setUser(login);
        setToken(login.token);
        return login;
    };

    // ==========================================
    // Facebook
    // ==========================================

    const loginFacebook = async () => {
        const login =
            await FirebaseAuthService.loginWithFacebook();
        setUser(login);
        setToken(login.token);
        return login;

    };

    // ==========================================
    // Apple
    // ==========================================

    const loginApple = async () => {
        const login =
            await FirebaseAuthService.loginWithApple();
        setUser(login);
        setToken(login.token);
        return login;

    };

    // ==========================================
    // Microsoft
    // ==========================================

    const loginMicrosoft = async () => {
        const login =
            await FirebaseAuthService.loginWithMicrosoft();
        setUser(login);
        setToken(login.token);
        return login;

    };

    // ==========================================
    // Déconnexion
    // ==========================================

    const logout = async () => {
        await FirebaseAuthService.logout();
        logoutStorage();
        setUser(null);
        setToken(null);
    };

    // ==========================================

    const value = {
        user,
        token,
        loading,
        isAuthenticated: !!token,
        loginGoogle,
        loginFacebook,
        loginApple,
        loginMicrosoft,
        logout

    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

// ==============================================

export const useAuth = () => {
    return useContext(AuthContext);

};